import { IconChevronLeft } from "@tabler/icons-react";
import { createPortal } from "react-dom";
import { ReactNode } from "react";

export const openModal = (id: string) => {
  const popUp = document.getElementById(id) as HTMLDialogElement;
  if (!popUp) {
    console.error(`Pop up ${id} not found.`);
    return;
  }
  if (popUp.hasAttribute("open")) return;
  if (typeof popUp.showModal === "function") {
    try {
      popUp.showModal();
    } catch {
      // ignore (e.g. already open)
    }
  } else {
    popUp.setAttribute("open", ""); // iOS 14 fallback
  }
};

export const closeModal = (id: string) => {
  const popUp = document.getElementById(id) as HTMLDialogElement;
  if (!popUp) {
    console.warn(`Closing Pop up ${id}. Not found.`);
    return;
  }
  if (typeof popUp.close === "function") {
    popUp.close();
  } else {
    popUp.removeAttribute("open");
  }
};

export const closeEveryModal = () => {
  document.querySelectorAll("dialog[open]").forEach((dialog) => {
    const d = dialog as HTMLDialogElement;
    if (typeof d.close === "function") {
      d.close();
    } else {
      d.removeAttribute("open");
    }
  });
};

const PopUp = ({
  id,
  children,
  position = "modal-middle",
  maxWidth = "",
  padding,
  title,
  onDismiss,
}: {
  id: string;
  children: ReactNode;
  position?: "modal-top" | "modal-middle" | "modal-bottom";
  maxWidth?: string;
  padding?: string;
  title: ReactNode;
  onDismiss?: () => void | Promise<void>;
}) => {
  const modalRoot = document.getElementById("modal-root") ?? document.body;
  const close = () => {
    if (onDismiss) onDismiss();
    closeModal(id);
  };
  return createPortal(
    <dialog
      id={id}
      className={`modal ${position} flex flex-col justify-center z-1`}
      onCancel={(e) => {
        e.preventDefault(); // prevent default Escape close
        onDismiss?.(); // let caller decide what happens
        closeModal(id); // then close
      }}
    >
      {/* The close button when a modal is opening from the bottom*/}
      {position === "modal-bottom" && (
        <div className="dialog w-full grow min-h-16">
          <button
            className="flex cursor-pointer w-full h-full justify-center items-end"
            onClick={close}
            type="button"
          ></button>
        </div>
      )}
      <div
        className={`modal-box p-0 ${maxWidth} glass-blurry bg-base-100/90  ${padding} ${position === "modal-top" && "safe-top-modal"} ${position === "modal-bottom" && "safe-bottom-modal"}`}
      >
        <div className="sticky flex p-2.5 items-center justify-center gap-2 top-0 z-11 w-full">
          <div className="badge p-4 w-full bg-base-300 shadow-lg truncate">
            <button
              className="absolute left-2.75 btn btn-sm btn-ghost btn-circle z-9"
              onClick={close}
              type="button"
            >
              <IconChevronLeft />
            </button>
            <h6 className="flex items-center gap-2 justify-center grow ml-4 truncate">
              {title}
            </h6>
          </div>
        </div>

        <div className="p-4">{children}</div>
      </div>

      {position === "modal-top" && (
        <form
          method="dialog"
          className="lg:hidden w-full grow min-h-24 touch-none"
        ></form>
      )}

      <div className="absolute inset-0 modal-backdrop">
        <button onClick={close} type="button">
          close
        </button>
      </div>
    </dialog>,
    modalRoot,
  );
};
export default PopUp;
